enum Tabs {
  General = 'general',
  Members = 'members',
  Environments = 'environments',
  Secrets = 'secrets',
}

type MatchParams = {
  tabId?: Tabs;
  teamId: string;
};

export { Tabs, MatchParams };
